import { Megaphone } from 'lucide-react';
import { createWebRegistrationFromManifest } from '@reflex/plugin-api/create-web-registration';
import { cannyWeb } from '../web-manifest.js';

export default createWebRegistrationFromManifest(
  cannyWeb,
  {
    CannyPage: () => import('./CannyPage'),
    CannyFlowTriggerSummary: () => import('./CannyFlowTriggerSummary'),
    CannyPostContextProvider: () => import('./CannyPostContextProvider'),
  },
  {
    icons: { Megaphone },
  },
);
